/**
 * Resolve company brand primary for DS accents.
 * Falls back to secondary (page bg green) when primary is missing.
 */
export function resolveBrandPrimaryColor(theme = {}) {
  const isValid = (color) =>
    typeof color === 'string' && color.trim() !== '' && color !== 'undefined';

  if (isValid(theme.primaryColor)) {
    return theme.primaryColor.trim();
  }
  if (isValid(theme.secondaryColor)) {
    return theme.secondaryColor.trim();
  }
  return '#36473F';
}

/**
 * Override DS theme tokens on a scoped container so accordion, buttons,
 * progress, and leadership avatar use the company color (not :root violet).
 */
export function buildBrandThemeStyle(primaryColor) {
  if (!primaryColor) {
    return undefined;
  }

  return {
    '--theme-color-1': primaryColor,
    '--ds-theme-action-primary': primaryColor,
    '--ds-theme-loader-arc': primaryColor,
    '--ds-theme-loader-track-fill': `color-mix(in srgb, ${primaryColor} 14%, var(--ds-color-white))`,
    '--ds-accordion-accent': primaryColor,
    '--ds-color-interactive-focus-ring': primaryColor,
    '--ds-theme-action-primary-light': `color-mix(in srgb, ${primaryColor} 12%, var(--ds-color-white))`,
    '--ds-theme-action-primary-gradient': `linear-gradient(135deg, color-mix(in srgb, ${primaryColor} 78%, var(--ds-color-white)) 0%, color-mix(in srgb, ${primaryColor} 48%, var(--pal-neutral-dark-1300)) 102.5%)`,
    '--ds-accordion-border-active': `color-mix(in srgb, ${primaryColor} 28%, var(--ds-color-white))`,
    '--ds-accordion-header-active-bg': `color-mix(in srgb, ${primaryColor} 10%, var(--ds-color-white))`,
    '--ds-button-primary-bg': primaryColor,
    '--ds-button-primary-hover': `color-mix(in srgb, ${primaryColor} 88%, var(--pal-neutral-dark-1300))`,
    '--ds-button-primary-active': `color-mix(in srgb, ${primaryColor} 72%, var(--pal-neutral-dark-1300))`,
  };
}
